import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=5dbceb90&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/myraj/m247/git/landing-pages/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dbceb90')) {
      api.createRecord('5dbceb90', component.options)
    } else {
      api.reload('5dbceb90', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=5dbceb90&", function () {
      api.rerender('5dbceb90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Form.vue"
export default component.exports